import lottie from 'lottie-web';
import { entersViewport } from '../modules/viewport';

export default function initAnimations() {
    if (document.body.contains(document.querySelector('[data-animate]'))) {
        const animationElements = document.querySelectorAll('[data-animate]');

        animationElements.forEach((animationElement) => {
            let init = 'screen';
            let timeout = 0;
            let autoplay = true;

            if (animationElement.hasAttribute('data-init')) {
                init = animationElement.getAttribute('data-init');
            }

            if (animationElement.hasAttribute('data-timeout')) {
                timeout = animationElement.getAttribute('data-timeout');
            }

            if (init !== 'screen' || timeout !== 0) {
                autoplay = false;
            }

            const animation = lottie.loadAnimation({
                container: animationElement, // the dom element that will contain the animation
                renderer: 'svg',
                loop: animationElement.getAttribute('data-loop'),
                autoplay,
                path: animationElement.getAttribute('data-source'),
            });

            if (init === 'screen') {
                function startAnimation(entersViewport) {
                    if (entersViewport) {
                        setTimeout(() => {
                            animation.play();
                        }, timeout);
                    }
                }

                startAnimation(entersViewport(animationElement)); // Initial
                document.addEventListener('scroll', () => {
                    startAnimation(entersViewport(animationElement));
                });
            } else if (timeout !== 0) {
                setTimeout(() => {
                    animation.play();
                }, timeout);
            }
        });
    }
}
